import { useEffect, useMemo, useState } from 'react';
import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { getUgcTrendsStats } from '@opm/services';
import { useStableValue } from '@opm/utils/stableKey';
import { IUgcTrendsStats } from '../types';

export function useUgcTrendsStats({
  filter,
  searchText = '',
}: {
  filter: any;
  searchText?: string;
}) {
  const [counts, setCounts] = useState<IUgcTrendsStats>({
    hot: 0,
    rising: 0,
    new: 0,
  });
  const { wrapperCancelRequest, loading } = useCancelRequestHook({
    clear: () => setCounts({ hot: 0, rising: 0, new: 0 }),
  });

  const stableFilter = useStableValue(filter);
  const stableSearchText = useStableValue(searchText);

  const params = useMemo(() => {
    if (!stableFilter) return null;
    return {
      ...stableFilter,
      search_text: stableSearchText,
    };
  }, [stableFilter, stableSearchText]);

  useEffect(() => {
    if (!params) return;
    wrapperCancelRequest(getUgcTrendsStats, params)
      .then((response: any) => {
        const { hot = 0, rising = 0, new: newCount = 0 } = response || {};
        setCounts({ hot, rising, new: newCount });
      })
      .catch(() => {});
  }, [params]);

  return { counts, loading };
}
